import { useState } from 'react';

interface TooltipProps {
  content: string; // Tooltip text
  children: React.ReactNode; // Element that triggers the tooltip
}

function Tooltip({ content, children }: TooltipProps) {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div className="tooltip-bubble">
          <div className="tooltip-text">{content}</div>
          <div className="tooltip-arrow" />
        </div>
      )}
    </div>
  );
}

export default Tooltip;
